import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationContext";
import { Bell, LogOut, HardHat } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export const EmployeeHeader = ({ title, subtitle }) => {
  const { user, logout } = useAuth();
  const { counts, setPanelOpen } = useNotifications();
  const unread = counts?.total || 0;

  const openBell = () => {
    if (unread === 0) {
      toast.info("No notifications", { id: "emp-no-notif" });
      return;
    }
    setPanelOpen(true);
  };

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-xl bg-indigo-600 text-white grid place-items-center shrink-0">
          <HardHat className="w-5 h-5" strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <h1 data-testid="emp-app-title" className="text-lg font-bold text-slate-900 truncate">{title || "My Work"}</h1>
          {subtitle ? <p className="text-xs text-slate-500 truncate">{subtitle}</p> : user && <p className="text-xs text-slate-500 truncate">{user.name} · {user.role_title}</p>}
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button onClick={openBell} data-testid="emp-bell-btn"
          className="relative h-10 w-10 rounded-full grid place-items-center text-slate-600 hover:bg-slate-100">
          <Bell className="w-5 h-5" strokeWidth={2.5} />
          {unread > 0 && (
            <span data-testid="emp-bell-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
        <Button variant="ghost" size="icon" onClick={logout} data-testid="emp-logout-btn"
          className="rounded-full h-10 w-10 text-slate-600 hover:text-red-600">
          <LogOut className="w-5 h-5" strokeWidth={2.5} />
        </Button>
      </div>
    </header>
  );
};
